<a [routerLink]="serviceRoute()" class="card card--clickable service-tile">
  <div class="card__container">
    @if (isLoading()) {
      <div class="card__container">
        <span class="service-tile__icon-container service-tile__available">
          <svg-icon src="assets/images/icons/{{ serviceIcon() }}.svg" class="service-tile__icon"></svg-icon>
        </span>
        <h3 class="service-tile__title">{{ serviceTitle() }}</h3>
        <div class="card__content">
          <ngx-skeleton-loader class="card__placeholder-message" count="1"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            appearance="circle"
            [theme]="{
              height: '20px',
              width: '20px',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    } @else {
      <span class="service-tile__icon-container service-tile__{{ serviceIcon() }}">
        <svg-icon src="assets/images/icons/{{ serviceIcon() }}.svg" class="service-tile__icon"></svg-icon>
      </span>

      <h3 class="service-tile__title">{{ serviceTitle() }}</h3>
      <div class="card__content">
        <p>{{ "Subscription.Message.None" | translate }}</p>
        <span> </span>

        <div class="service-tile__bottom">
          <div class="service-tile__status__flex">
            <div class="service-tile__status">
              <svg-icon
                src="assets/images/icons/status-ok.svg"
                [matTooltip]="'Dashboard.Wireless.Locations' | translate"
                [matTooltipPosition]="'above'"
              ></svg-icon>
              <div class="service-tile__status__number">{{ subscriptionCount() }}</div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</a>
